import { render, staticRenderFns } from "./ContestCard.vue?vue&type=template&id=006b0f44&scoped=true&"
import script from "./ContestCard.vue?vue&type=script&lang=js&"
export * from "./ContestCard.vue?vue&type=script&lang=js&"
import style0 from "./ContestCard.vue?vue&type=style&index=0&id=006b0f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b0f44",
  null
  
)

export default component.exports